import { Category } from "@domain/models/Category";
import { Creditor, Debitor } from "@domain/models/Creditor";

export { Tag } from "@domain/models/Tag";
export { Payment } from "@domain/models/Payment";
export { GenericRecord, GenericItem } from "@domain/models/GenericRecord";

export type CCDCombinedType = Creditor | Debitor | Category;

export { Category, Creditor, Debitor };
